import React, { FC, useState } from 'react'
import { Icon, Layout, Button, Modal } from 'antd'

import styles from './index.module.less'
import User from '../User'
import { useBreakpoints, EndCustomerAccountForm } from '../../components'
import { endCustomerService } from '../../services'

import { EndCustomerFormValues } from '../../types'
import GroupSelector from '../GroupSelector'
import { useAuth } from '../../providers/AuthProvider'
import Maintenance from '../Maintenance'

const { Header: AntHeader } = Layout

interface HeaderProps {
	collapsed: boolean
	children?: JSX.Element | string
	setCollapsed(collapsed: boolean): void
}

const Header: FC<HeaderProps> = ({ collapsed, setCollapsed, children }) => {
	const breakpoints = useBreakpoints()
	const [isCustomerModalVisible, setIsCustomerModalVisible] = useState<boolean>(false)
	const { userHasPermission } = useAuth()

	const toggleCollapsed = (): void => setCollapsed(!collapsed)
	const createEndCustomer = async (values: EndCustomerFormValues): Promise<void> => {
		await endCustomerService.create(values)
		setIsCustomerModalVisible(false)
	}

	return (
		<AntHeader className={styles.header}>
			<div className={styles.row}>
				<Icon className={[styles.icon, styles.trigger].join(' ')} type={collapsed ? 'menu-unfold' : 'menu-fold'} onClick={toggleCollapsed} />
				{children && children}
				<div style={{ display: 'inline-flex', alignItems: 'center' }}>
					<Button onClick={() => setIsCustomerModalVisible(true)} type='link' icon='plus'>
						{breakpoints.sm || 'New end customer'}
					</Button>
					{userHasPermission(['User.Self.Group.Change']) && <GroupSelector />}
					<Maintenance />
					<div className={styles.avatar}>
						<User />
					</div>
				</div>
			</div>
			<Modal
				// centered looks a lot better on mobile/shorter devices
				destroyOnClose
				centered={breakpoints.md}
				visible={isCustomerModalVisible}
				onCancel={(): void => setIsCustomerModalVisible(false)}
				title={'Create a new end customer'}
				footer={null}
			>
				<EndCustomerAccountForm submit={createEndCustomer} />
			</Modal>
		</AntHeader>
	)
}

export default Header
